module.exports = __webpack_public_path__ + "6aa9e3814996a14d776e9ed057b5a4f9.svg";